const Aux = (props) => (
    <div className={props.className} style={props.inlineStyle}>
        {props.children}
    </div>
)
export default Aux;